<div class="mt-3" style="width: 441px;">
  <div class="d-flex justify-content-between">
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Roteiros</span>
      <span class="info-val">{{ roteirosNumeros }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Peso Bruto</span>
      <span class="info-val">{{ dados.PesoBrutoTotal }}kg/{{ dados.CapacidadePesoVeiculo}}kg</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Cubagem</span>
      <span class="info-val">{{ dados.Cubagem }}m³/{{ dados.CapacidadeVolumeVeiculo}}m³</span>
    </div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Prev. saida</span>
      <span class="info-val">{{ util.converteData(dados.PrevisaoSaida) | date: 'dd/MM/yyyy' }} - {{ util.converteData(dados.PrevisaoSaida) | date: 'hh:mm' }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Tempo Estimado</span>
      <span class="info-val">{{ tempoEstimado? tempoEstimado + ':00' :   dados.TempoEstimado? dados.TempoEstimado.split('T')[1].split('.')[0] :0 }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Versão do app</span>
      <span class="info-val">{{ versaoApp }}</span>
    </div>
  </div>
  <hr>

  <div class="d-flex justify-content-between mt-3">
    <span class="info-destaque">{{ dados.veiculo }}</span>
    <span class="d-flex align-items-center" (click)="toggleEdicao()"> <img src="assets/img/icons/icon-lapis-green.svg" alt="" width="16px"> <app-texto-link  titulo="Editar" class="ms-2"></app-texto-link ></span>
  </div>
  <div class="d-flex justify-content-between mt-3">
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Motorista</span>
      <span class="info-val">{{ dados.nome_motorista }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Ajudante 1</span>
      <span class="info-val">{{ nomeAjudantePrimeiro?? '-'}}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Ajudante 2</span>
      <span class="info-val">{{ nomeAjudanteSegundo?? '-'}}</span>
    </div>
  </div>

  <hr>

  <p class="mt-3 info-destaque">Valores</p>
  <div class="d-flex justify-content-between ">
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Pedidos</span>
      <span class="info-val">{{ dados.ValorPedido | currency:'BRL':true }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Pedágio</span>
      <span class="info-val">R$ {{infoRota.ValorPedagio! | currency:'BRL':true }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Descargar</span>
      <span class="info-val">R$ 0,00</span>
    </div>
  </div>

  <div class="d-flex mt-3">
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Custo Km</span>
      <span class="info-val">R$ {{infoRota.CustoKM | currency:'BRL':true }}</span>
    </div>
    <div class="d-flex flex-column col-4">
      <span class="info-tit">Custo total</span>
      <span class="info-val">R$ {{ infoRota.CustoTotal | currency:'BRL':true }}</span>
    </div>
  </div>

</div>
